import OnboardingContainerWrapper from './containers/OnboardingContainerWrapper';

export default OnboardingContainerWrapper;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/index.js